export const userSortModes = {
    user: 'user',
    organization: 'organization',
    lastName: 'lastName',
    firstName: 'firstName',
    email: 'email',
};
